/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: conserver les mises à jour du panier.
 * - openCart: passer directement au paiement.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () =>
      document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const root = window.Shopify?.routes?.root || '/';
      window.location.assign(root + 'checkout');
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}